import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../theme.js';
import CaseBillingModal from './CaseBillingModal.js';
const CaseBilling = (props) => {
    const lang = useSelector((s) => s.lang);
    const [modalOpen, setModalOpen] = useState(false);
    return (React.createElement("p", { style: { fontSize: '0.9em', margin: 0 } },
        React.createElement("b", { style: {
                color: THEME.COLOR_ACCENT,
                cursor: 'pointer',
            }, onClick: () => {
                setModalOpen(!modalOpen);
            } }, lang.clientBilling.seeDetails),
        modalOpen && (React.createElement(CaseBillingModal, { onToggle: () => setModalOpen(!modalOpen), caseId: props.caseId, tenantId: props.tenantId, creditorId: props.creditorId, currency: props.currency }))));
};
export default CaseBilling;
//# sourceMappingURL=CaseBilling.js.map